import SafetyIncidents from '../incidents/pages/SafetyIncidents';
import { AlertDetailsModal } from '../rides/features/AlertNav/LiveAlerts/AlertDetailsModal';
import { CancelRideModal } from '../rides/features/CancelRide';
import { EditRideFormModal } from '../rides/features/EditRide';
import { RebuildRideFormModal } from '../rides/features/RebuildRide';
import RideDetails from '../rides/pages/RideDetails';

const privateRoutes = [
  {
    path: '/rides/:rideSlug',
    title: 'Ride Details',
    component: RideDetails,
    nestedRoutes: [
      {
        path: 'edit',
        component: EditRideFormModal,
      },
      {
        path: 'alert/:alertId',
        component: AlertDetailsModal,
      },
      {
        path: 'rebuild',
        component: RebuildRideFormModal,
      },
      {
        path: 'cancel',
        component: CancelRideModal,
      },
    ],
    roles: ['super_admin', 'admin', 'live-ops', 'live-ops_admin', 'trust_safety'],
  },
  {
    path: '/safety-incidents',
    title: 'Trust and Safety Incidents',
    component: SafetyIncidents,
    roles: ['trust_safety', 'trust_safety_admin'],
  },
];
const publicRoutes = [];

export { privateRoutes, publicRoutes };
